// extracted by mini-css-extract-plugin
module.exports = {"form":"_9GXOd8S3nCRAoLJY36eQf","label-margin":"_21VgkfWkg04zB60fa9upnP","description-margin":"_1AYxn6AkdBvPRFaJMEzhaj"};